













































































import { Component, Vue } from 'vue-property-decorator';
import { api } from '@/api';
import { appName } from '@/env';
import QrcodeVue from 'qrcode.vue';

@Component({
  components: {
    QrcodeVue
  }
})
export default class Setup2FA extends Vue {
  public otpcode: string = '';
  public appName = appName;
  public otpurl: string = '';
  public dialogReset2FA: boolean = false;

  // Lifecycle Functions
  public async created() {
    const response = await api.postAction(
      this.$store,
      '/users/me/setup_otp_create'
    );
    if (response) {
      this.otpurl = (response.data as any).url;
      if ((response.data as any).status === 'AlreadySetup') {
        this.dialogReset2FA = true;
      }
    }
  }
  public async submit() {
    const response = await api.postAction(
      this.$store,
      '/users/me/setup_otp_verify',
      {
        code: this.otpcode
      }
    );
    if (response) {
      if ((response.data as any).status === 'Ok') {
        this.$router.push('/');
      }
    }
  }
  public async reset2FA() {
    const response = await api.postAction(this.$store, '/users/me/reset_otp');
    if (response) {
      this.otpurl = (response.data as any).url;
    }
  }
}
